import { render, staticRenderFns } from "./i-ginvoice.vue?vue&type=template&id=7af7d91a&"
import script from "./i-ginvoice.vue?vue&type=script&lang=js&"
export * from "./i-ginvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports